export const CalendarIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_15039_36512" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15039_36512)">
        <path
          d="M3.33333 14.6693C2.96667 14.6693 2.65267 14.5388 2.39133 14.2779C2.13044 14.0166 2 13.7026 2 13.3359V4.0026C2 3.63594 2.13044 3.32216 2.39133 3.06127C2.65267 2.79994 2.96667 2.66927 3.33333 2.66927H4V1.33594H5.33333V2.66927H10.6667V1.33594H12V2.66927H12.6667C13.0333 2.66927 13.3473 2.79994 13.6087 3.06127C13.8696 3.32216 14 3.63594 14 4.0026V13.3359C14 13.7026 13.8696 14.0166 13.6087 14.2779C13.3473 14.5388 13.0333 14.6693 12.6667 14.6693H3.33333ZM3.33333 13.3359H12.6667V6.66927H3.33333V13.3359Z"
          fill="#C8A311"
        />
      </g>
    </svg>
  );
};
